import React, { Fragment, Component } from 'react'
import { Link } from 'react-router-dom'
import yn from 'yn'
import { MenuMobileContainer } from 'App/MainMenu/MenuMobile'
import MediaQuery from 'react-responsive'
import { getButton } from 'Shared/GTM/getButton'

class MobileMenuLogged extends Component {
  constructor (props) {
    super(props)

    this.profileMenuState = this.profileMenuState.bind(this)
    this.callReset = this.callReset.bind(this)
    this.activePage = this.activePage.bind(this)

    this.state = {
      isHomeOrGuest: false,
      isHelpPage: false,
      isWishlistPage: false,
      isCartPage: false,
      profileMenu: false,
      userMenu: false,
      stateMenu: true,
      categoryMenu: false,
      showIuppMobileMenu: false
    }
  }

  openProfileMenu = () => {
    setTimeout(() => {
      if (this.state.userMenu === true) {
        this.setState({
          profileMenu: false,
          userMenu: false
        })
        const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button')
        if (allButtonsAndLinks && allButtonsAndLinks.length > 0) {
          Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
            buttonOrLink.removeAttribute('aria-hidden')
          })
        }
      } else {
        const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button')
        if (allButtonsAndLinks && allButtonsAndLinks.length > 0) {
          Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
            buttonOrLink.setAttribute('aria-hidden', 'true')
          })
        }
        this.setState({
          profileMenu: true,
          userMenu: true,
          categoryMenu: false,
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false
        })
      }
    }, 300)
  }

  openCategoryMenu = () => {
    setTimeout(() => {
      if (this.state.categoryMenu === true) {
        this.setState({
          categoryMenu: false
        })
        const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button')
        if (allButtonsAndLinks && allButtonsAndLinks.length > 0) {
          Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
            buttonOrLink.removeAttribute('aria-hidden')
          })
        }
      } else {
        const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button')
        if (allButtonsAndLinks && allButtonsAndLinks.length > 0) {
          Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
            buttonOrLink.setAttribute('aria-hidden', 'true')
          })
        }

        this.setState({
          profileMenu: false,
          userMenu: false,
          categoryMenu: true,
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false
        })
      }
    }, 300)
  }

  callReset = e => {
    this.setState({
      stateMenu: !this.state.stateMenu
    })
    if (
      !this.state.stateMenu ||
      this.state.categoryMenu ||
      this.state.userMenu
    ) {
      setTimeout(() => {
        this.setState({
          profileMenu: false,
          userMenu: false,
          categoryMenu: false
        })
      }, 300)
    }
  }

  closeMenu = () => {
    var checkMenu = document.getElementById('menuToggle')
    if (checkMenu && checkMenu.checked === true) {
      checkMenu.checked = false
    }
    this.callReset()
  }

  // Apenas para o modo responsivo
  activePage = () => {
    this.closeMenu()
    setTimeout(() => {
      var activeRoute = window.location.pathname.substring(
        window.location.pathname.lastIndexOf('/')
      )

      if (activeRoute === '/') {
        if (this.state.userMenu === true) {
          const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button')
          if (allButtonsAndLinks && allButtonsAndLinks.length > 0) {
            Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
              buttonOrLink.removeAttribute('aria-hidden')
            })
          }
        }

        this.setState({
          isHomeOrGuest: true,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (activeRoute === '/faq') {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: true,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (
        activeRoute === '/profile' ||
        activeRoute === '/wishlist' ||
        activeRoute === '/extract' ||
        activeRoute === '/my-orders' ||
        activeRoute === '/my-address' ||
        activeRoute === '/scheduling'
      ) {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: true,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (activeRoute === '/cart') {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: true,
          showIuppMobileMenu: false
        })
      } else {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      }
    }, 1)
  }

  profileMenuState = () => {
    this.setState({
      profileMenu: !this.state.profileMenu
    })
  }

  componentDidMount () {
    this.activePage()
  }

  toggleMenuMobileIupp = (section) => {
    this.setState({
      showIuppMobileMenu: !this.state.showIuppMobileMenu,
      isHomeOrGuest: !this.state.isHomeOrGuest
    })

    if (
      section === '#experiences' ||
      section === '#accumulatePoints' ||
      section === '#usePoint' ||
      section === '#benefits'
    ) {
      setTimeout(() => {
        document.querySelector(`${section} h2`).focus()
      }, 300)
    }
  }

  keyPressMenu = (e) => {
    if (e.which === 13) {
      this.toggleMenuMobileIupp()
    }
  }

  render () {
    return (
      <Fragment>
        <MediaQuery maxWidth={1025}>
          <div className='box-footer d-print-none'>
            <div className='box-footer-mobile'>
              <div className='container-footer footer-part-mobile bg-brand-2 container-fluid row mx-0 px-0'>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.isHomeOrGuest ? 'active' : 'inactive'
                  }`}>
                  <Link
                    to='/'
                    className='color-ui-white txt-body-sm d-flex justify-content-center'
                    onClick={() => {
                      this.activePage()
                      getButton(true, 'home', 'clique:menu', 'ir-para-home')
                    }}
                    role='button'
                    tabIndex={0}
                    aria-label='Início'
                  >
                    <i className='color-ui-white icon icon_home' aria-hidden='true' />
                    <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                      Início
                    </p>
                  </Link>
                </div>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.showIuppMobileMenu ? 'active' : 'inactive'
                  }`}
                >
                  <Fragment>
                    <a
                      className='not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center'
                      onClick={() => {
                        this.openCategoryMenu()
                        getButton(true, 'home', 'clique:menu', 'menu')
                      }}
                      aria-haspopup='true'
                      aria-expanded={this.state.categoryMenu}
                      role='button'
                      href='javascript:void(0)'
                      tabIndex={0}
                      aria-label='Menu'
                    >
                      <i className={`color-${
                        this.state.categoryMenu
                          ? 'brand-6 txt-body'
                          : 'brand-5'
                      } mt-0 icon icon_${
                        this.state.categoryMenu
                          ? 'menu_app_close'
                          : 'menu_app'
                      }`} aria-hidden='true' />
                      <p className='pos-absolute t-2 txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                        {yn(this.state.categoryMenu) ? 'Fechar' : 'Menu'}
                      </p>
                    </a>
                    {this.state.categoryMenu && (
                      <MenuMobileContainer
                        stateMenu={this.state.stateMenu}
                        callReset={this.callReset}
                        profileMenu={this.state.profileMenu}
                        profileMenuState={this.profileMenuState}
                        categoryMenu={this.state.categoryMenu}
                        userMenu={this.state.userMenu}
                        activePage={this.activePage}
                      />
                    )}
                  </Fragment>
                </div>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.isCartPage ? 'active' : 'inactive'
                  }`}
                >
                  <Link
                    to='/cart'
                    className='color-ui-white txt-body-sm d-flex justify-content-center'
                    onClick={() => {
                      this.activePage()
                      getButton(true, 'home', 'clique:menu', 'carrinho')
                    }}
                    tabIndex={0}
                    aria-label='Carrinho'
                    role='button'
                  >
                    <i className={`color-${
                      this.state.isCartPage ? 'brand-6' : 'brand-5'
                    } icon icon_cart`} aria-hidden='true' />
                    <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                      Carrinho
                    </p>
                  </Link>
                </div>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.isProfile ? 'active' : 'inactive'
                  }`}
                >
                  <Fragment>
                    <a
                      className='not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center'
                      aria-haspopup='true'
                      aria-expanded={this.state.userMenu}
                      onClick={() => {
                        this.openProfileMenu()
                        getButton(true, 'home', 'clique:menu', 'perfil')
                      }}
                      role='button'
                      href='javascript:void(0)'
                      tabIndex={0}
                      aria-label='Perfil'
                    >
                      <i className={`color-${
                        this.state.userMenu ? 'brand-6' : 'brand-5'
                      } mt-0 icon icon_${
                        this.state.profileMenu
                          ? 'menu_app_close'
                          : 'profile'
                      } ${
                        this.state.userMenu ? 'brand-6 txt-body' : 'brand-5'
                      }`} aria-hidden='true' />
                      <p className='pos-absolute t-2 txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                        Perfil
                      </p>
                    </a>
                    {this.state.userMenu && (
                      <MenuMobileContainer
                        stateMenu={this.state.stateMenu}
                        callReset={this.callReset}
                        profileMenu={this.state.profileMenu}
                        profileMenuState={this.profileMenuState}
                        categoryMenu={this.state.categoryMenu}
                        userMenu={this.state.userMenu}
                        activePage={this.activePage}
                      />
                    )}
                  </Fragment>
                </div>
                {yn(process.env.REACT_APP_HAS_FAQ_LINK) && (
                  <div
                    className={`col px-0 d-flex justify-content-center ${
                      this.state.isHelpPage ? 'active' : 'inactive'
                    }`}
                  >
                    <Link to='/redirect/faq'
                      className='color-ui-white txt-body-sm d-flex justify-content-center'
                      onClick={() => {
                        this.activePage()
                        getButton(true, 'home', 'clique:menu', 'ajuda')
                      }}
                      tabIndex={0}
                      aria-label='Ajuda'
                      role='button'
                    >
                      <i className={`color-ui-white icon icon_headphone`} aria-hidden='true' />
                      <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                        Ajuda
                      </p>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </MediaQuery>
      </Fragment>
    )
  }
}

export default MobileMenuLogged



// WEBPACK FOOTER //
// ./src/App/Footer/MobileMenuLogged.js